import React, { createElement, useEffect, useState } from 'react';
import { View, StyleSheet } from 'react-native';

function DateTimePicker({
  value,
  onChange,
  type = 'date',
  style,
}: {
  value?: string;
  onChange: (event: any) => void;
  type?: 'date' | 'time';
  style?: any;
}) {
  return createElement('input', {
    type,
    value,
    onInput: onChange,
    style,
  });
}

function parseTime(time: string) {
  const timestamp = Date.parse(time);
  const date = new Date(timestamp);
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    hour12: false,
    minute: 'numeric',
  });
}

function parseDate(date: string) {
  const timestamp = Date.parse(date);
  const d = new Date(timestamp);
  return d.toISOString().split('T')[0];
}

export function TimePicker({ value, onChange }) {
  const currentDate = new Date();
  const [time, setTime] = useState(parseTime(value || currentDate));
  const [date, setDate] = useState(parseDate(value || currentDate));

  useEffect(() => {
    const newTime = `${date} ${time}`;
    if (newTime !== value) {
      onChange(newTime);
    }
  }, [onChange, time, date, value]);

  return (
    <View style={style.container}>
      <DateTimePicker
        value={date}
        onChange={(v) => setDate(v.target.value)}
        style={style.input}
      />
      <DateTimePicker
        value={time}
        onChange={(v) => setTime(v.target.value)}
        type="time"
        style={style.input}
      />
    </View>
  );
}

const style = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  numberContainer: {
    flexDirection: 'row',
  },
  number: {
    borderWidth: 1,
    borderRightWidth: 0,
    borderColor: 'grey',
    paddingBottom: 2,
    width: 30,
    textAlign: 'center',
  },
  dropdown: {
    marginBottom: 0,
    borderRadius: 0,
    paddingVertical: 5,
    paddingHorizontal: 5,
  },
  input: {
    borderWidth: 1,
    borderColor: 'grey',
    padding: 5,
    borderRadius: 0,
    marginBottom: 10,
    fontFamily:
      'BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
});
